import i18n from "i18next";

import { getDateStringLocale } from "@/i18n/getDateFnsLocale.ts";

export function getTimezoneAbbreviation(timezone: string): string {
  return (
    new Intl.DateTimeFormat(getDateStringLocale(i18n.language), {
      timeZoneName: "short",
      timeZone: timezone,
    })
      .formatToParts(new Date())
      .find((part) => part.type === "timeZoneName")?.value || timezone
  );
}
